import { defineStore } from 'pinia';

function generateUniqueId() {
    return Date.now().toString() + '-' + Math.random().toString(36).substr(2, 9);
}

export const useOrderStore = defineStore('order', {
    state: () => {
        const storedItems = JSON.parse(localStorage.getItem('orderItems')) || [];

        const items = storedItems.map(item => {
            if (!item.uniqueCartId) {
                return {
                    ...item,
                    uniqueCartId: generateUniqueId(),
                    quantity: item.quantity || 1,
                };
            }

            if (!item.quantity || item.quantity < 1) {
                return {
                    ...item,
                    quantity: 1,
                };
            }

            return item;
        });

        if (storedItems.length !== items.length || storedItems.some((item) => {
            return (
                !item.uniqueCartId ||
                item.quantity === undefined ||
                item.quantity < 1
            );
        })) {
            localStorage.setItem('orderItems', JSON.stringify(items));
        }

        return {
            items,
        };
    },
    actions: {
        addItem(item) {
            const uniqueCartId = generateUniqueId();
            const newItem = {
              ...item,
              uniqueCartId,
              quantity: 1,
            };
            this.items.push(newItem);
            this.updateLocalStorage();
          },

        removeItem(uniqueCartId) {
            // Find the exact index of the item with this uniqueCartId
            const index = this.items.findIndex(item => item.uniqueCartId === uniqueCartId);
            
            if (index !== -1) {
              this.items.splice(index, 1);
              this.updateLocalStorage();
            }
          },

        updateItemQuantity(uniqueCartId, newQuantity) {
            const item = this.items.find(item => item.uniqueCartId === uniqueCartId);
            if (item) {
                item.quantity = newQuantity >= 1 ? newQuantity : 1;
                this.updateLocalStorage();
            }
        },
        
        clearItems() {
            this.items = [];
            this.updateLocalStorage();
        },

        updateLocalStorage() {
            localStorage.setItem('orderItems', JSON.stringify(this.items));
        },
    },
    getters: {
        totalAmount(state) {
            return state.items.reduce((acc, item) => {
                const price = parseFloat(item.pickedBox.price) || 0;
                const quantity = item.quantity || 1;
                return acc + price * quantity;
            }, 0);
        },
    },
});
